import React from 'react';
import { TabsWrapper } from 'src/styles/button.style';
import { TabsPanelHeader } from 'src/styles/panel.style';
import { BunkerRegTabsEnum } from '../BunkeringUtils';
import { BunkerRegTabButton } from '../Bunkering.styles';

interface BunkerRegTabsHeaderProps {
    selectedBunkerRegTab: BunkerRegTabsEnum;
    setSelectedBunkerRegTab: (tab: BunkerRegTabsEnum) => void;
}

const BunkerRegTabsHeader: React.FC<BunkerRegTabsHeaderProps> = ({ selectedBunkerRegTab, setSelectedBunkerRegTab }) => {
    return (
        <TabsPanelHeader columns={'80% 20%'} height={'40px'}>
            <TabsWrapper>
                <BunkerRegTabButton
                    className="first"
                    isSelected={selectedBunkerRegTab === BunkerRegTabsEnum.fuelReceived}
                    onClick={() => {
                        setSelectedBunkerRegTab(BunkerRegTabsEnum.fuelReceived);
                    }}
                >
                    Fuel received
                </BunkerRegTabButton>
                <BunkerRegTabButton
                    className="seperate-from-group"
                    isSelected={selectedBunkerRegTab === BunkerRegTabsEnum.status}
                    onClick={() => {
                        setSelectedBunkerRegTab(BunkerRegTabsEnum.status);
                    }}
                >
                    Statuses
                </BunkerRegTabButton>
            </TabsWrapper>
        </TabsPanelHeader>
    );
};

export default BunkerRegTabsHeader;
